import { Injectable } from "@angular/core";
import { HeaderInterceptorService } from "src/app/interceptors/header-interceptor";

@Injectable()
export class ReportsService {
  constructor(private customAxios: HeaderInterceptorService) {}

  /**
   * @name getAllReportConfiguration
   * @return Promise
   * @description fetch all report configuration
   */
  getAllReportConfiguration() {
    return this.customAxios.get(`ReportConfiguration/GetAllReportConfiguration`);
  }

  /**
   * @name deleteReportConfiguration
   * @param {number} reportConfigurationId
   * @retur Promise
   */
  deleteReportConfiguration(reportConfigurationId: number) {
    return this.customAxios.get(
      `ReportConfiguration/DeleteReportConfiguration?id=${reportConfigurationId}`
    );
  }

  /**
   * @name getAllModule
   * @return Promise
   * @description fetch all module
   */
  getAllModule() {
    return this.customAxios.get(`ReportConfiguration/GetAllModule`);
  }

  /**
   * @name addReportConfiguration
   * @param payload, reportConfigurationId
   * @method POST
   * @return Promise
   */
  addReportConfiguration(payload: any, reportConfigurationId?: any) {
    if (reportConfigurationId) {
      return this.customAxios.post(
        "ReportConfiguration/UpdateReportConfiguration",
        payload
      );
    } else {
      return this.customAxios.post("ReportConfiguration/AddReportConfiguration", payload);
    }
  }

  /**
   * @name getReportConfigurationById
   * @param reportConfigurationId
   * @method get
   * @return Promise
   */
  getReportConfigurationById(reportConfigurationId: any) {
    return this.customAxios.get(
      `ReportConfiguration/GetReportConfigurationById?id=${reportConfigurationId}`
    );
  }

  /**
   * @name getAllUserReport
   * @return Promise
   * @description fetch all user reports
   */
  getAllUserReport() {
    return this.customAxios.get(`UserReport/GetAllUserReport`);
  }

  /**
   * @name getAllAccounts
   * @return Promise
   * @description fetch all user accounts
   */
  getAllAccounts() {
    return this.customAxios.get(`Account/GetAllAccounts`);
  }

  /**
   * @name deleteUserReport
   * @param {number} userReportId
   * @retur Promise
   */
  deleteUserReport(userReportId: number) {
    return this.customAxios.get(`UserReport/DeleteUserReport?id=${userReportId}`);
  }

  /**
   * @name addUserReport
   * @method POST
   * @return Promise
   */
  addUserReport(payload: any, userReportId?: any) {
    if (userReportId) {
      return this.customAxios.post("UserReport/UpdateUserReport", payload);
    } else {
      return this.customAxios.post("UserReport/AddUserReport", payload);
    }
  }

  /**
   * @name getUserReportById
   * @param userReportId
   * @method get
   * @return Promise
   */
  getUserReportById(userReportId: any) {
    return this.customAxios.get(`UserReport/GetUserReportById?id=${userReportId}`);
  }

  /**
   * @name getAllCustomerCompanyBranchId
   * @param {number} companyBranchId
   * @retur Promise
   */
  getAllCustomerCompanyBranchId(companyBranchId: number) {
    return this.customAxios.get(
      `Customer/GetAllCustomerCompanyBranchId?companyBranchId=${companyBranchId}`
    );
  }
  /**
   * @name GetAllCustomerCompanyBranchId
   * @param {number} companyBranchId
   * @retur Promise
   */
  getAllCustomerByCompanyBranchId(companyBranchId: number) {
    return this.customAxios.get(
      `Customer/GetAllCustomerByCompanyBranchId?companyBranchId=${companyBranchId}`
    );
  }

    /**
   * @name getAllCustomerByGenerateReport
   * @param {number} companyBranchId
   * @param {number} userId
   * @retur Promise
   */
     getAllCustomerByGenerateReport(companyBranchId: number, userId: number, paymentTypeId: number) {
      return this.customAxios.get(
        `Customer/GetAllCustomerByGenerateReport?companyBranchId=${companyBranchId}&userId=${userId}&paymentTypeId=${paymentTypeId}`
      );
    }

  /**
   * @name GetCustomerBranchByCustomerId
   * @param {number} customerId
   * @retur Promise
   */
  getCustomerBranchByCustomerId(customerId: number) {
    return this.customAxios.get(
      `CustomerBranch/GetCustomerBranchByCustomerId?customerId=${customerId}`
    );
  }
  /**
   * @name GetCustomerBranchByCustomerIdANDCompanyBranchId
   * @param {number} customerId
   * @retur Promise
   */
  GetCustomerBranchByCustomerIdANDCompanyBranchId(
    customerId: number,
    companyBranchId
  ) {
    return this.customAxios.get(
      `CustomerBranch/GetCustomerBranchByCustomerIdANDCompanyBranchId?customerId=${customerId}&companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name GetAllAssignedReportConfiguration
   * @param {number} customerId
   * @retur Promise
   */
  getAllAssignedReportConfiguration(
    userSequence: number,
    moduleId: number,
    isAdministrator?: any
  ) {
    if (isAdministrator) {
      return this.customAxios.get(
        `/ReportConfiguration/GetAllAssignedReportConfiguration?userSequence=${userSequence}&moduleId=${moduleId}&isAdministrator=${isAdministrator}`
      );
    } else {
      return this.customAxios.get(
        `/ReportConfiguration/GetAllAssignedReportConfiguration?userSequence=${userSequence}&moduleId=${moduleId}`
      );
    }
  }

  /**
   * @name GetAllDrivers
   * @return Promise
   * @description fetch all GetAllDrivers
   */
  getAllDrivers() {
    return this.customAxios.get(`Driver/GetAllDrivers`);
  }

  /**
   * @name generateReport
   * @return Promise
   * @description fetch all generateReport
   */
  generateReport(payload: any) {
    if (payload) {
      // let query = '';
      // var keys = Object.keys(payload);
      // keys.forEach(x => {
      //     query += (x + '=' + payload[x] + '&');
      // });
      // query = query.slice(0, -1);
      return this.customAxios.post(`Report/GenerateReport`, payload);
    }
  }

  /**
   * @name getAllCompanyBranches
   * @return Promise
   * @description fetch all company branches
   */
  getAllCompanyBranches() {
    return this.customAxios.get(`CompanyBranch/GetAllCompanyBranches`);
  }

  /**
   * @name getAllCompanyBranches
   * @return Promise
   * @description fetch all company branches
   */
  getAllCompanyBranchesByCompanyBranchId(companyBranchId: number) {
    return this.customAxios.get(
      `CompanyBranch/GetAllCompanyBranches?companyBranchId=${companyBranchId}`
    );
  }
  /**
   * @name getAllCompanyBranchesByUserId
   * @return Promise
   * @description fetch all company branches
   */
   getAllCompanyBranchesByUserId(userId: number, companyId: number, isAdministrator: boolean) {
    return this.customAxios.get(
      `CompanyBranch/GetAllCompanyBranchesByUserId?userId=${userId}&companyId=${companyId}&isAdministrator=${isAdministrator}`
    );
  }

  /**
   * @name getAllItemTypes
   * @return Promise
   * @description fetch all item types
   */
  getAllItemTypes() {
    return this.customAxios.get(`ItemType/GetAllItemTypes`);
  }

  /**
   * @name getAllMaterials
   * @return Promise
   * @description fetch all getAllMaterials
   */
  getAllMaterials() {
    return this.customAxios.get(`Material/GetAllMaterials`);
  }

  /**
   * @name getFocalsByItemTypeMasterId
   * @param itemTypeMasterId
   * @return Promise
   * @description fetch all getFocalsByItemTypeMasterId
   */
  getFocalsByItemTypeMasterId(itemTypeMasterId: number) {
    return this.customAxios.get(
      `Focal/GetFocalsByItemTypeMasterId?itemTypeMasterId=${itemTypeMasterId}`
    );
  }

  /**
   * @name getBrandByItemTypeMasterId
   * @param {event}  itemTypeMasterId
   * @return brandsList
   * @description fetch data by id
   *
   */
  getBrandsForItemCatalog(
    itemTypeMasterId: number,
    focalId: number,
    materialId: number
  ) {
    return this.customAxios.get(
      "Brand/GetBrandsForItemCatalog?itemTypeMasterId=" +
        itemTypeMasterId +
        "&focalId=" +
        focalId +
        "&materialId=" +
        materialId
    );
  }

  /**
   * @name getAllBrandMasters
   * @return Promise
   * @description fetch all getAllBrandMasters
   */
  getAllBrandMasters() {
    return this.customAxios.get(`BrandMaster/GetAllBrandMasters`);
  }

  /**
   * @name getAllStockTypess
   * @service InventoryService
   * @param payload
   * @method POST
   * @return Promise
   */
  getAllStockTypes(payload: any) {
    return this.customAxios.get(
      `ItemCatalog/GetAllStockTypes?MaterialId=${payload.materialId}&FocalId=${payload.focalId}&BrandMasterId=${payload.brandMasterId}&SubBrandMasterId=${payload.subBrandMasterId}&ItemTypeMasterId=${payload.itemTypeMasterId}&VendorId=${payload.vendorId}`
    );
  }

  /**
   * @name getAllSalesOrderTypes
   * @return Promise
   * @description fetch all sales order types
   */
  getAllSalesOrderTypes() {
    return this.customAxios.get(`SalesOrderType/GetAllSalesOrderTypes`);
  }

  /**
   * @name generateReportInventory
   * @return Promise
   * @description add inventory report
   */
  generateReportInventory(payload: any) {
    return this.customAxios.post(`Report/GenerateReportInventory`, payload);
  }
  /**
   * @name accountDetailTypes
   * @return Promise
   * @description fetch all account details types
   */
  accountDetailTypes() {
    return this.customAxios.get(`AccountDetailTypes`);
  }

  /**
   * @name getAllAccountsByAccountDetailTypeId
   * @param accountHeadDetailTypeId
   * @return Promise
   * @description fetch all accountHeadDetailTypeId
   */
  getAllAccountsByAccountDetailTypeId(accountHeadDetailTypeId: number, companyBranchId?: number) {
    return this.customAxios.get(
      `ChartOfAccounts/GetAllAccountsByParentId?accountHeadDetailTypeId=${accountHeadDetailTypeId}&companyBranchId=${companyBranchId ? companyBranchId : 0}`
    );
  }

  /**
   * @name getAllItemTypeMaster
   * @returns Promise
   * @description fetch all ItemType
   */
  getAllItemTypeMaster(companyBranchId: number) {
    return this.customAxios.get(
      "ItemType/GetAllItemTypeMaster?companyBranchId=" + companyBranchId
    );
  }

  /**
   * @name getSPH
   * @param {number} range1
   * @param {number} range2
   * @returns sph range
   * @memberof salesService
   */
  getSPH(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetSPH?range1=${range1}&range2=${range2}`);
  }

  /**
   * @name getCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getCYL(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetCYL?range1=${range1}&range2=${range2}`);
  }

  /**
   * @name getADDF
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getADDF(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetADDF?range1=${range1}&range2=${range2}`);
  }

   /**
   * @name getAllAssignEmployee
   * @param {number} userId
   * @param {number} reportConfigurationId
   * @returns cyl range
   * @memberof salesService
   */
   getAllAssignEmployee(userId: number, reportConfigurationId: number) {
    return this.customAxios.get(`AssignEmployee/GetAllAssignEmployee?userId=${userId}&reportConfigurationId=${reportConfigurationId}`);
  }

  /**
   * @name getAccountsByParentId
   * @param parentId 
   * @param search 
   * @returns 
   */
  getAccountsByParentId(parentId: number, search: string){
    return this.customAxios.get(`ChartOfAccounts/AccountsByParentId?parentId=${parentId}&search=${search}`);
  }

    /**
   * @name accounts
   * @retur Promise
   */
    accounts(search: string) {
      return this.customAxios.get(`ChartOfAccounts/accounts?search=${search}`);
    }

    /**
   * @name getCOA
   * @param coaLevelId 
   * @returns 
   */
 getCOA(coaLevelId: number) {
  return this.customAxios.get(
    `ChartOfAccounts/GetCOA?coaLevelId=${coaLevelId}`
  );
}
/**
   * @name getCOALevel6
   * @param accountId 
   * @returns 
   */
getCOALevel6(accountId: number) {
  return this.customAxios.get(
    `ChartOfAccounts/GetCOALevel6?accountId=${accountId}`
  );
}
}
